import React, { useEffect, useRef } from "react";
import classes from "./control-panel.scss";
import { ICON_COUNT_TEXT } from "../../constants";

// The icons page toolbar: search, the page's filters (children), then grid / list
const ControlPanel = ({
  state,
  onSearch,
  layoutToggleHandler,
  isHorizontal,
  children,
}) => {
  const searchInput = useRef(null);
  const query = state.searchTxt || "";

  // "/" jumps to the search box from anywhere on the page, unless you're already typing
  useEffect(() => {
    const onKey = (ev) => {
      if (ev.key !== "/" || ev.metaKey || ev.ctrlKey || ev.altKey) return;
      const target = ev.target;
      if (target.isContentEditable || /^(INPUT|TEXTAREA|SELECT)$/.test(target.tagName)) return;
      ev.preventDefault();
      searchInput.current.focus();
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, []);

  const clearSearch = () => {
    onSearch("");
    searchInput.current.focus();
  };
  return (
    <section className={classes.section}>
      <div className={classes.wrap}>
        <div className={classes.search} role="search">
          <svg
            className={classes.searchIcon}
            width="22"
            height="22"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
            onClick={() => searchInput.current.focus()}
          >
            <path
              d="M14.667 25.333c5.89 0 10.666-4.775 10.666-10.666S20.558 4 14.667 4 4 8.776 4 14.667c0 5.89 4.776 10.666 10.667 10.666ZM28 28l-5.8-5.8"
              stroke="currentColor"
              strokeWidth="2.4"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <input
            ref={searchInput}
            type="search"
            aria-label="Search icons"
            placeholder={`Search ${ICON_COUNT_TEXT} icons`}
            autoComplete="off"
            spellCheck="false"
            onChange={(ev) => onSearch(ev.target.value)}
            onKeyDown={(ev) => {
              if (ev.key === "Escape" && query) {
                ev.preventDefault();
                onSearch("");
              }
            }}
            value={query}
            name="icofont__search"
          />
          {query ? (
            <button
              type="button"
              className={classes.searchClear}
              onClick={clearSearch}
              aria-label="Clear search"
              title="Clear search (Esc)"
            >
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <path d="M18 6 6 18M6 6l12 12" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" />
              </svg>
              <span>Clear</span>
            </button>
          ) : (
            <kbd className={classes.searchHint} title="Press / to search">/</kbd>
          )}
        </div>
        {children ? <div className={classes.filters}>{children}</div> : null}
        <div className={classes.sortList}>
          <button
            type="button"
            onClick={() => layoutToggleHandler(false)}
            className={!isHorizontal ? classes.active : ""}
            aria-pressed={!isHorizontal}
            aria-label="Grid view"
            title="Grid view"
          >
          <svg width="24" height="24" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <path
              d="M13.333 4H4v9.333h9.333V4ZM28 4h-9.333v9.333H28V4ZM28 18.667h-9.333V28H28v-9.333ZM13.333 18.667H4V28h9.333v-9.333Z"
              stroke="#000"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          </button>
          <button
            type="button"
            onClick={() => layoutToggleHandler(true)}
            className={isHorizontal ? classes.active : ""}
            aria-pressed={isHorizontal}
            aria-label="List view"
            title="List view"
          >
          <svg width="24" height="24" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <path
              d="M5.333 14v4h21.334v-4H5.333ZM5.333 24v4h21.334v-4H5.333ZM5.333 4v4h21.334V4H5.333Z"
              stroke="#000"
              // stroke-opacity=".4"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          </button>
        </div>
      </div>
    </section>
  );
};

export default ControlPanel;
